import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns'

class EditableDateCell extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {editing: false};
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this._handleClickOutside = this._handleClickOutside.bind(this);
    // this._handleDatepickerClick = this._handleDatepickerClick.bind(this);
    this._datePicker = React.createRef();
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.error && this.props.cellData !== nextProps.cellData) {
      return {
        error: null
      }
    }
    return null;
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    console.log(info.componentStack);
  }

  handleClick (e) {
    //console.log("event "+e.target)
    this.setState({editing:true});

  }

  // _handleDatepickerClick (e) {
  //   e.stopPropagation();
  //   e.nativeEvent.stopImmediatePropagation();
  //   console.log("date picker click event "+e.target)
  //
  // }

  handleChange(date, event) {

    // if (this._datePicker && this._datePicker.current ) {
    //   this._datePicker.current.setOpen(false);
    // }
    //console.log("change event:", event)
    if (event.nativeEvent.type==="input" && event.key !== 'Enter') {
      // we should ignore key presses unless it's enter
      return
    }
    this.setState({editing:false}, ()=> {
      this.props.column.onValueChange({
        rowData: this.props.rowData,
        rowIndex: this.props.rowIndex,
        column: this.props.column,
        value: date.getTime()
      });

    });
  }

  _handleClickOutside(e) {
    // let oldValue = this.props.cellData;
    // let value = e.target.value;
    // console.log(value)
    // if (oldValue === value.getTime()) {
    //   return;
    // }
    //
    // this.props.column.onValueChange(this.props.rowIndex, value.getTime());
    this.setState({editing:false});
  }

  render() {
    var inputField = null;
    let locale = 'US';//this.appController.getLocale();
    if (!this.state.error && this.state.editing) {
      //console.log("Render datepicker")
      inputField = <DatePicker
        ref={this._datePicker}
        startOpen={true}
        shouldCloseOnSelect={true}
        onClickOutside={this._handleClickOutside}
        selected={this.props.cellData}
        onSelect={this.handleChange}
        //onClick={this._handleDatepickerClick}
        //locale={locale}
      />
    } else {
      //console.log("Render a date")
      inputField = format(new Date(this.props.cellData), 'MM/dd/yyyy', locale);
    }
    return (

      <div onClick={this.state.editing? null : this.handleClick}
           className={"EditableTableCell " + (this.state.error?"ErrorInData": "")}
           key={""+this.props.rowIndex+":"+this.props.columnIndex}
      >
        { inputField }
      </div>

    );
  }
}


EditableDateCell.propTypes = {
  column: PropTypes.shape({
    onValueChange: PropTypes.func.isRequired
  }),
  container: PropTypes.any.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowData: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  // editing: PropTypes.bool.isRequired,
  cellData: PropTypes.any
};


export default EditableDateCell;